import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import React from 'react';
import c from 'classnames';
import { BiDataHook } from '@wix/da-bi/pkg/constants';
import s from './FooterRowLayout.scss';
const FooterRowLayout = (_param)=>/*#__PURE__*/ {
    var { blocks, className } = _param, rest = _object_without_properties(_param, [
        "blocks",
        "className"
    ]);
    return React.createElement("div", _object_spread({
        className: c(s['root'], className),
        // TODO: Move this to a FooterLayoutRoot component if we need more than one layout.
        "data-hook": BiDataHook.COMMENT_FOOTER
    }, rest), blocks);
};
FooterRowLayout.displayName = 'FooterRowLayout';
export default FooterRowLayout;
